/**
 * Where a Core-minted SSO bridge token may land.
 *
 * WHY THIS IS ONE CONSTANT AND NOT TWO STRING LITERALS
 *
 * Two independent places must agree: the router, which needs a route for the
 * path, and AppShell's gate, which must render the bridge page WITHOUT chrome
 * and without redirecting to login first. If either accepts a path the other
 * does not, the failure is silent and nasty - the user arrives holding a VALID
 * bridge token and is shown a login page. That reads as "SSO is broken" and
 * sends whoever debugs it to the auth code, which is fine.
 *
 * THE MIGRATION THIS EXISTS FOR
 *
 * Core currently emits `<host>/auth/bridge`. The canonical URL model (Pattern A,
 * doc 24) mounts Discovery under a path on the tenant's Core host, so the target
 * becomes `<slug>.foctta.com/discovery/auth/bridge`.
 *
 * The receiver widens FIRST and the sender switches SECOND. That ordering is not
 * a preference: our step is backwards-compatible and theirs is not, so if Core
 * switched first there would be a window where a real customer's cross-launch is
 * dead - and Motilal is on that path. Accepting both costs nothing and removes
 * the window entirely.
 *
 * The bare-root form stays until Core has switched and soaked. Deleting it early
 * re-opens the same window from the other side.
 */

/** Bridge landing paths, accepted simultaneously during the Pattern A migration. */
export const BRIDGE_PATHS = ['/auth/bridge', '/discovery/auth/bridge'] as const;

/**
 * True when a pathname is a bridge landing.
 *
 * `startsWith`, matching the gate it replaced: the SPA route carries the token
 * in the URL FRAGMENT (`#t=…`) so it is never sent to a server in a Referer
 * header, but a trailing slash or an appended segment must still match.
 */
export function isBridgePath(pathname: string): boolean {
  return BRIDGE_PATHS.some((p) => pathname.startsWith(p));
}
